const config = {
	timezone: "Asia/Singapore",
	apiURL: window.ENV.API_URL || "http://localhost:8103/api",
	ossUrl: window.ENV.OSS_URL || "https://img-sit.omgplay.cyou/public/",
};

export default config;
